module.exports = __webpack_public_path__ + "img/light-bulb.4f399c12.png";